module.exports = __webpack_public_path__ + "static/img/banner.3e85d62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qmyd/banner.jpg
// module id = 3MMv
// module chunks = 36